import type { AblyLogger } from "./types";

const CONFIRM_SEND_TIMEOUT_MS = Number(import.meta.env.VITE_ABLY_CONFIRM_SEND_TIMEOUT_MS) || 3000;

export const ABLY_CONFIG = {
	disconnectedRetryTimeout: 1000,
	suspendedRetryTimeout: 5000,
	presenceRetryDelayMs: 2000,
	publishRetryDelayMs: 1000,
	maxPublishRetries: 5,
	confirmSendTimeoutMs: CONFIRM_SEND_TIMEOUT_MS,
	reconnectionPopupDurationMs: 3000,
} as const;

type AblyRuntimeConfig = {
	logger: AblyLogger;
};

const noopLogger: AblyLogger = {
	info: () => {},
	warning: () => {},
	error: () => {},
	debug: () => {},
};

let _runtimeConfig: AblyRuntimeConfig = {
	logger: noopLogger,
};

export function configureAbly(config: Partial<AblyRuntimeConfig>): void {
	_runtimeConfig = {
		..._runtimeConfig,
		...config,
	};
}

export function getRuntimeConfig(): AblyRuntimeConfig {
	return _runtimeConfig;
}
